import { lzFIsArray } from '@lz/services/Type';

export interface LzNOption {
  value: string;
  text: string;
  [key: string | number]: any;
}

class LzMOption implements LzNOption {
  value: string;
  text: string;
  [key: string | number]: any;

  constructor(
    model?: any,
    valueField?: string,
    textField?: string,
    extraFields?: string[]
  ) {
    valueField = valueField || 'value';
    textField = textField || 'text';

    this.value = model?.[valueField] || '';
    this.text = model?.[textField] || '';

    if ('' === this.value && typeof model?.id !== 'undefined') {
      this.value = model.id;
    }
    if ('' === this.text && typeof model?.name !== 'undefined') {
      this.text = model.name;
    }

    if ('' === this.value && typeof model?.value !== 'undefined') {
      this.value = model.value;
    }
    if ('' === this.text && typeof model?.text !== 'undefined') {
      this.text = model.text;
    }

    if (extraFields) {
      for (const field of extraFields) {
        this[field] = model?.[field] || '';
      }
    }

    // console.log('LOADED-OPTs', model, this);
  }

  static parseArray(
    data: any,
    valueField?: string,
    textField?: string,
    extraFields?: string[]
  ): LzMOption[] {
    if (!lzFIsArray) {
      return [];
    }

    const out: LzMOption[] = [];

    for (const item of data) {
      out.push(new LzMOption(item, valueField, textField, extraFields));
    }

    return out;
  }
}

export default LzMOption;
